import { observer } from "mobx-react";
import { h, Fragment } from "preact";
import { t, translate } from "restaumatic-client";
import AvailabilityDebugInfo from "../../components/AvailabilityDebugInfo";
function CartSummaryRows(props) {
    const { deliveryPriceInCurrentZone, deliveryPriceAfterDiscounts, packagingPrice, depositPrice, promotions, tip, } = props;
    const isTipVisible = tip !== undefined &&
        tip !== null &&
        tip.numericValue !== null &&
        tip.numericValue > 0;
    return (h("div", { "aria-live": "polite" },
        promotions &&
            promotions.map((promotion) => {
                var _a;
                return (h(Fragment, null,
                    h(CostRow, { label: promotion.name, value: (_a = promotion.value) !== null && _a !== void 0 ? _a : "" }),
                    h(AvailabilityDebugInfo, { name: "PromotionInstance", fieldId: "promotionInstance.availability", availability: promotion.availability })));
            }),
        h(DeliveryCostRow, { label: translate(t.restaurants.widgets.cart.delivery.delivery_cost), beforeValue: deliveryPriceInCurrentZone, afterValue: deliveryPriceAfterDiscounts }),
        packagingPrice !== null && (h(CostRow, { label: translate(t.cart.packagingContainersCost), value: packagingPrice })),
        depositPrice !== null && (h(CostRow, { label: translate(t.cart.depositCost), value: depositPrice })),
        isTipVisible && (h(CostRow, { label: translate(t.formtastic.labels.order.tip), value: tip.priceValue }))));
}
function DeliveryCostRow(props) {
    const { label, beforeValue, afterValue } = props;
    if (beforeValue === null) {
        return null;
    }
    const isFree = afterValue === null && beforeValue !== null;
    return (h("div", { class: "d-flex align-items-baseline" },
        h("div", { class: "u-flex-grow" }, label),
        isFree && (h("span", { class: "m-badge m-badge--success u-mr2 u-text-uppercase" }, translate(t.client.general.free))),
        h("div", { class: isFree ? "u-text-line-through" : undefined }, beforeValue)));
}
function CostRow(props) {
    const { label, value } = props;
    return (h("div", { class: "d-flex align-items-baseline" },
        h("div", { class: "u-flex-grow u-text-break u-mr2" }, label),
        h("div", null, value)));
}
export default observer(CartSummaryRows);
